var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('advertisement-top-banner-text'), _c('advertisement-fashion-middle'), _c('div', {
    attrs: {
      "else": ""
    }
  }, [_c('b-container', {
    staticClass: "pl-5 pr-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "mt-5"
  }, [_c('b-col', {
    staticClass: "bg-lightgray",
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "text-grey"
  }, [_c('div', {
    staticClass: "mt-3 mx-3"
  }, [_c('h5', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Filters")]), _c('hr')]), _c('div', [_c('h5', {
    staticClass: "font-weight-bold ml-3"
  }, [_vm._v("Category")]), _vm._l(this.isCategoryList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "custom-control custom-checkbox collection-filter-checkbox mx-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.selected,
        expression: "item.selected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": item.name
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : item.selected
      },
      on: {
        "change": [function ($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(item, "selected", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(item, "selected", $$c);
          }
        }, function ($event) {
          return _vm.onChangeCategory($event);
        }]
      }
    }), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": item.name
      }
    }), _vm._v(" " + _vm._s(item.name) + " ")]);
  })], 2), _c('hr'), _c('div', [_c('h5', {
    staticClass: "font-weight-bold ml-3"
  }, [_vm._v("Product Types")]), _vm._l(_vm.productTypeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "custom-control custom-checkbox collection-filter-checkbox mx-3"
    }, [_c('input', {
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": item.name
      },
      domProps: {
        "value": item.name
      },
      on: {
        "change": function ($event) {
          return _vm.onChangeProductType($event);
        }
      }
    }), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": item.name
      }
    }), _vm._v(" " + _vm._s(item.name) + " ")]);
  })], 2), _c('hr'), _c('div', [_c('h5', {
    staticClass: "font-weight-bold ml-3"
  }, [_vm._v("Size")]), _vm._l(_vm.sizes, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "custom-control custom-checkbox collection-filter-checkbox mx-3"
    }, [_c('input', {
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": item.text
      },
      domProps: {
        "value": item.value
      },
      on: {
        "change": function ($event) {
          return _vm.onChangeSize($event);
        }
      }
    }), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": item.text
      }
    }), _vm._v(" " + _vm._s(item.text) + " ")]);
  })], 2), _c('hr'), _c('div', [_c('h5', {
    staticClass: "font-weight-bold ml-3"
  }, [_vm._v("Colours")]), _vm._l(_vm.color, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "custom-control custom-checkbox collection-filter-checkbox mx-3"
    }, [_c('input', {
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": item.text
      },
      domProps: {
        "value": item.value
      },
      on: {
        "change": function ($event) {
          return _vm.onChangeColour($event);
        }
      }
    }), _c('span', {
      class: `${item.value}`
    }), _c('label', {
      staticClass: "color-code custom-control-label",
      attrs: {
        "for": item.text
      }
    }), _vm._v(" " + _vm._s(item.text) + " ")]);
  })], 2)])]), _c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('h5', {
    staticClass: "ml-4"
  }, [_vm._v(" " + _vm._s(this.$route.params.data) + " ")])]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "3"
    }
  }, [_c('div', [_c('b-form-select', {
    staticClass: "form-select filter-select form-control border",
    attrs: {
      "options": _vm.options
    },
    on: {
      "input": function ($event) {
        return _vm.onChangeSort($event);
      }
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)])], 1)], 1)], 1), _c('div', [_vm.categoryListItems.length > 0 ? _c('div', [_c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.categoryListItems,
      "hasBackground": false,
      "hasButton": false,
      "showTitle": true,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 113096431)
  })], 1) : _c('div', {
    staticClass: "text-center no-item"
  }, [_vm._v(" " + _vm._s(_vm.$t("productStore.noItmes")) + " ")])])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }